import { useAuthStore } from '@/stores/auth.store';
import { can } from '@/lib/permissions';

export function usePermission(required: string): boolean {
  const perms = useAuthStore((s) => s.user?.permissions ?? []);
  return can(perms, required);
}
